"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90036],{

/***/ 5077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CustomLoading = function(param) {
    var decrease_width = param.decrease_width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            " fixed h-screen top-0 right-0 bg-gray-500   bg-opacity-25",
            , 
        ].join(" "),
        style: {
            zIndex: "999999999999999999999999999999999999999999999999999",
            width: decrease_width ? "calc(100VW - ".concat(decrease_width, "px)") : "100vW"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: " w-full h-full flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-primary "
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLoading);


/***/ }),

/***/ 46316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var ErrorComponent = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-1/2 transform -translate-x-1/2 -mb-64 bottom-0 pointer-events-none z-[-1]",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "1360",
                    height: "578",
                    viewBox: "0 0 1360 578",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                x1: "50%",
                                y1: "0%",
                                x2: "50%",
                                y2: "100%",
                                id: "illustration-01",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#FFF",
                                        offset: "0%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#EAEAEA",
                                        offset: "77.402%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#DFDFDF",
                                        offset: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            fill: "url(#illustration-01)",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "1232",
                                    cy: "128",
                                    r: "128"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "155",
                                    cy: "443",
                                    r: "64"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-6xl mx-auto px-4 sm:px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pt-16 pb-12 md:pt-20 md:pb-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-3xl mx-auto text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "h1 mb-4",
                                children: "Oh, No! You stumbled upon a rarity"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "btn text-white bg-blue-600 hover:bg-blue-700",
                                        children: "Go back home"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 90036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth_Sign_in; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Auth/Google.jsx
var Google = __webpack_require__(25470);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/uuidv4/build/lib/uuidv4.js
var uuidv4 = __webpack_require__(26281);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/Shared/Alert/Alert.jsx
var Alert = __webpack_require__(21550);
// EXTERNAL MODULE: ./src/Shared/Loader/Button_loading.jsx
var Button_loading = __webpack_require__(86707);
// EXTERNAL MODULE: ./constant/url.js
var url = __webpack_require__(99741);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./constant/functions.js
var functions = __webpack_require__(60538);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.module.js
var mixpanel_module = __webpack_require__(83198);
// EXTERNAL MODULE: ./constant/mixpnael.js
var mixpnael = __webpack_require__(70441);
// EXTERNAL MODULE: ./src/Shared/CustomLoading.jsx
var CustomLoading = __webpack_require__(5077);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/utils/discourse_auth.js
var discourse_auth = __webpack_require__(65233);
// EXTERNAL MODULE: ./src/utils/tradly_integration_auth.js
var tradly_integration_auth = __webpack_require__(20435);
;// CONCATENATED MODULE: ./src/components/Auth/actions/SignIn.js












var sign_in_handler = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var setIsLoading, data, is_log_in_by_discourse, is_log_in_by_tradly_integration, redirect_url, sso, sig, router, setOpenAlert, setAlert_type, setMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            setIsLoading = param.setIsLoading, data = param.data, is_log_in_by_discourse = param.is_log_in_by_discourse, is_log_in_by_tradly_integration = param.is_log_in_by_tradly_integration, redirect_url = param.redirect_url, sso = param.sso, sig = param.sig, router = param.router, setOpenAlert = param.setOpenAlert, setAlert_type = param.setAlert_type, setMessage = param.setMessage;
            setIsLoading(true);
            axios_default().post("/api/login", {
                user: data
            }).then(function(res) {
                // console.log(res)
                axios_default().get("/api/user_tenants_details", {
                    params: {
                        auth_key: res.data.user.key.auth_key
                    }
                }).then(function(res2) {
                    var ref, ref1, ref2, ref3;
                    (0,lib.deleteCookie)(url.auth_cookie_name);
                    (0,lib.deleteCookie)(url.refresh_cookie_name);
                    (0,lib.deleteCookie)(url.uuid_cookie_name);
                    (0,lib.deleteCookie)(url.tenant_cookie_name);
                    (0,lib.deleteCookie)(url.global_auth_cookie_name);
                    // cookie setting
                    if (!res.data.user.email_verified) {
                        (0,lib.setCookie)(url.global_auth_cookie_name, (0,functions.encryptDataWithAES)(JSON.stringify(res.data.user)), {
                            maxAge: 86400,
                            domain: url.cookies_domain_name,
                            path: "/"
                        });
                    } else {
                        (0,lib.setCookie)(url.auth_cookie_name, (0,functions.encryptDataWithAES)(res.data.user.key.auth_key), {
                            maxAge: 86400,
                            domain: url.cookies_domain_name,
                            path: "/"
                        });
                        (0,lib.setCookie)(url.uuid_cookie_name, (0,functions.encryptDataWithAES)((0,uuidv4/* uuid */.Vj)()), {
                            maxAge: 860400,
                            domain: url.cookies_domain_name,
                            path: "/"
                        });
                        (0,lib.setCookie)(url.refresh_cookie_name, (0,functions.encryptDataWithAES)(res.data.user.key.refresh_key), {
                            maxAge: 860400,
                            domain: url.cookies_domain_name,
                            path: "/"
                        });
                        (0,lib.setCookie)("auth_expiry_time", Date.now() + 86400000, {
                            domain: url.cookies_domain_name,
                            path: "/",
                            maxAge: 86400
                        });
                    }
                    // mixpanel call
                    (0,mixpnael/* MixpanelIdentifyCall */.JP)((ref = res.data.user) === null || ref === void 0 ? void 0 : ref.email);
                    var _obj;
                    (0,mixpnael/* MixpanelTracking */.n5)(mixpnael/* MixpanelEventName.sign_in */.aK.sign_in, (_obj = {}, (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_name */.Oe.user_name, res.data.user.name), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_email */.Oe.user_email, (ref1 = res.data.user) === null || ref1 === void 0 ? void 0 : ref1.email), _obj));
                    var default_tenant = (ref2 = res2.data.data.tenants) === null || ref2 === void 0 ? void 0 : ref2.find(function(tenant) {
                        return tenant === null || tenant === void 0 ? void 0 : tenant.default;
                    });
                    //
                    if (((ref3 = res2.data.data.tenants) === null || ref3 === void 0 ? void 0 : ref3.length) > 1 && !is_log_in_by_discourse && !is_log_in_by_tradly_integration) {
                        var ref4;
                        (0,lib.setCookie)(url.tenant_cookie_name, (0,functions.encryptDataWithAES)((ref4 = res2.data.data.tenants) === null || ref4 === void 0 ? void 0 : ref4.filter(function(tenant) {
                            return tenant === null || tenant === void 0 ? void 0 : tenant.default;
                        })[0].id), {
                            maxAge: 860400,
                            domain: url.cookies_domain_name,
                            path: "/"
                        });
                        if (!res.data.user.email_verified) {
                            axios_default().get("/api/auth/verification_link?auth_key=".concat(res.data.user.key.auth_key)).then(function(res) {
                                router.push("/verify_email?to=".concat(redirect_url));
                            });
                        } else {
                            if ((default_tenant === null || default_tenant === void 0 ? void 0 : default_tenant.super_user) && !(default_tenant === null || default_tenant === void 0 ? void 0 : default_tenant.onboarding_completed)) {
                                router.push("/onboarding?to=".concat(redirect_url));
                            } else {
                                router.push("/tenants?to=".concat(redirect_url));
                            }
                        }
                    } else {
                        if (is_log_in_by_discourse) {
                            (0,discourse_auth/* discourse_redirect */.kM)({
                                sso: sso,
                                sig: sig,
                                router: router,
                                user: res.data.user
                            });
                        } else if (is_log_in_by_tradly_integration) {
                            (0,tradly_integration_auth/* tradly_integration_redirect */.we)({
                                sso: sso,
                                sig: sig,
                                router: router,
                                user: res.data.user
                            });
                        } else {
                            if (!res.data.user.email_verified) {
                                axios_default().get("/api/auth/verification_link?auth_key=".concat(res.data.user.key.auth_key)).then(function(res) {
                                    router.push("/verify_email?to=".concat(redirect_url));
                                });
                            } else {
                                if ((default_tenant === null || default_tenant === void 0 ? void 0 : default_tenant.super_user) && !(default_tenant === null || default_tenant === void 0 ? void 0 : default_tenant.onboarding_completed)) {
                                    router.push("/onboarding?to=".concat(redirect_url));
                                } else {
                                    router.push(redirect_url);
                                }
                            }
                        }
                    }
                });
                setIsLoading(false);
            }).catch(function(err) {
                var ref, ref1;
                var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
                setIsLoading(false);
                if (message) {
                    setOpenAlert(true);
                    setAlert_type("error");
                    setMessage(message);
                } else {
                    if (message) {
                        setOpenAlert(true);
                        setAlert_type("error");
                        setMessage("Something is wrong , please try latter");
                    }
                }
            });
            return [
                2
            ];
        });
    });
    return function sign_in_handler(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/Auth/Sign_in.jsx



















var Sign_in = function(param) {
    var sso = param.sso, sig = param.sig, is_log_in_by_discourse = param.is_log_in_by_discourse, is_log_in_by_tradly_integration = param.is_log_in_by_tradly_integration, isLoggedIn = param.isLoggedIn;
    var router = (0,next_router.useRouter)();
    var redirect_url = router.query.to || url.default_site_url;
    // Alert
    var ref = (0,react.useState)(false), open_alert = ref[0], setOpenAlert = ref[1];
    var ref1 = (0,react.useState)(""), message = ref1[0], setMessage = ref1[1];
    var ref2 = (0,react.useState)("success"), alert_type = ref2[0], setAlert_type = ref2[1];
    //
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(null), countries = ref4[0], setCountries = ref4[1];
    // react hook form
    var ref5 = (0,index_esm/* useForm */.cI)(), register = ref5.register, handleSubmit = ref5.handleSubmit, setValue = ref5.setValue, errors = ref5.formState.errors;
    //
    (0,react.useEffect)(function() {
        setValue("uuid", (0,uuidv4/* uuid */.Vj)());
        setValue("type", "tenant");
        axios_default().get("/api/countries").then(function(res) {
            var ref;
            setCountries((ref = res.data.countries_res) === null || ref === void 0 ? void 0 : ref.countries);
            if (res.data.IP_COUNTRY) {
                var ref1;
                setValue("metadata.country_id", (ref1 = res.data.countries_res) === null || ref1 === void 0 ? void 0 : ref1.countries.find(function(cn) {
                    return cn.code2 == res.data.IP_COUNTRY;
                }).id);
            } else {
                var ref2;
                setValue("metadata.country_id", (ref2 = res.data.countries_res) === null || ref2 === void 0 ? void 0 : ref2.countries[0].id);
            }
        }).catch(function(err) {
            var ref, ref1;
            var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
            setIsLoading(false);
            if (message) {
                setOpenAlert(true);
                setAlert_type("error");
                setMessage(message);
            } else {
                if (message) {
                    setOpenAlert(true);
                    setAlert_type("error");
                    setMessage("Something is wrong , please try latter");
                }
            }
        });
    }, [
        router
    ]);
    // Submit login form
    var onSubmit = function(data) {
        sign_in_handler({
            setIsLoading: setIsLoading,
            data: data,
            is_log_in_by_discourse: is_log_in_by_discourse,
            is_log_in_by_tradly_integration: is_log_in_by_tradly_integration,
            redirect_url: redirect_url,
            sso: sso,
            sig: sig,
            router: router,
            setOpenAlert: setOpenAlert,
            setAlert_type: setAlert_type,
            setMessage: setMessage
        });
    };
    var _query;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                className: " w-full md:w-[400px] lg:w-[450px]   fixed bottom-0 md:bottom-5   right-0 z-[9999999999999999999999999999999999999999999999999] ",
                type: alert_type,
                open: open_alert,
                setOpen: setOpenAlert,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: message
                })
            }),
            isLoggedIn && sso && sig && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLoading/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "bg-gradient-to-b from-gray-100 to-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-6xl mx-auto px-4 sm:px-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pt-16 pb-12 md:pt-20 md:pb-20 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-3xl mx-auto text-center pb-12 md:pb-20",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "h1",
                                        children: "Welcome back. Sign in"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-w-sm mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            onSubmit: handleSubmit(onSubmit),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-wrap -mx-3 mb-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full px-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "block text-gray-800 text-sm font-medium mb-1",
                                                                htmlFor: "email",
                                                                children: "Email"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                id: "email",
                                                                type: "email"
                                                            }, register("email")), {
                                                                className: "form-input w-full text-gray-800",
                                                                placeholder: "Enter your email address",
                                                                required: true
                                                            }))
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-wrap -mx-3 mb-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full px-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex justify-between",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    className: "block text-gray-800 text-sm font-medium mb-1",
                                                                    htmlFor: "password",
                                                                    children: "Password"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                id: "password",
                                                                type: "password"
                                                            }, register("password")), {
                                                                className: "form-input w-full text-gray-800",
                                                                placeholder: "Enter your password",
                                                                required: true
                                                            }))
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-wrap -mx-3 mt-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-full px-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            type: "submit",
                                                            disabled: isLoading,
                                                            className: "btn text-white bg-blue-600 hover:bg-blue-700 w-full flex items-center justify-center gap-4 ".concat(isLoading && "cursor-not-allowed"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Sign in"
                                                                }),
                                                                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_loading/* default */.Z, {
                                                                    text_color: "text-white"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-gray-600 text-center mt-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/forgot_password",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: " text-blue-600 hover:underline transition duration-150 ease-in-out",
                                                            children: "Forgot password?"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Don’t you have an account?",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: {
                                                                pathname: "/signup",
                                                                query: (_query = router.query) !== null && _query !== void 0 ? _query : {
                                                                    to: "https://superadmin.tradly.app"
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: " ml-2 text-blue-600 hover:underline transition duration-150 ease-in-out",
                                                                children: "Sign up"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Auth_Sign_in = (Sign_in);


/***/ }),

/***/ 65233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kM": function() { return /* binding */ discourse_redirect; },
/* harmony export */   "wL": function() { return /* binding */ check_discourse_payload; }
/* harmony export */ });
/* unused harmony export validateSignature */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46316);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42474);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12918);
/* provided dependency */ var process = __webpack_require__(83454);




// validateSignature
var validateSignature = function(payload, providedSig, secret) {
    try {
        var hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", secret);
        hmac.update(payload);
        var calculatedSig = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", secret).update(payload).digest("hex");
        return calculatedSig === providedSig;
    } catch (error) {
        console.error("Error validating signature:", error);
        return false;
    }
};
var check_discourse_payload = function(param) {
    var component = param.component, sso = param.sso, sig = param.sig;
    var decodedPayload = decodeBase64(sso);
    var ref = decodedPayload ? JSON.parse('{"' + decodeURI(decodedPayload === null || decodedPayload === void 0 ? void 0 : decodedPayload.replace(/&/g, '","').replace(/=/g, '":"')) + '"}') : {}, nonce = ref.nonce, return_sso_url = ref.return_sso_url;
    var discourseConnectSecret = process.env.DISCOURSE_SSO_SECRET;
    var isValidSignature = validateSignature(sso, sig, discourseConnectSecret);
    if (isValidSignature) {
        return component;
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
};
var decodeBase64 = function(encodedString) {
    try {
        var decodedString = atob(encodedString);
        return decodedString;
    } catch (error) {
        console.error("Error decoding Base64:", error);
        return null;
    }
};
var discourse_redirect = function(param) {
    var sso = param.sso, sig = param.sig, router = param.router, user = param.user;
    var decodedPayload = decodeBase64(sso);
    var ref = JSON.parse('{"' + decodeURI(decodedPayload.replace(/&/g, '","').replace(/=/g, '":"')) + '"}'), nonce = ref.nonce, return_sso_url = ref.return_sso_url;
    var payloadObj = {
        nonce: nonce,
        email: user.email,
        external_id: user.id,
        username: user.email,
        name: user.name
    };
    var encodedPayload = btoa(new URLSearchParams(payloadObj).toString());
    var discourseConnectSecret = process.env.DISCOURSE_SSO_SECRET;
    var hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", discourseConnectSecret);
    hmac.update(encodedPayload);
    var signature = hmac.digest("hex");
    var queryParams = new URLSearchParams({
        sso: encodedPayload,
        sig: signature
    });
    window.location.href = "".concat(decodeURIComponent(return_sso_url), "?").concat(queryParams.toString());
};


/***/ }),

/***/ 20435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K4": function() { return /* binding */ check_tradly_auth_integration_payload; },
/* harmony export */   "we": function() { return /* binding */ tradly_integration_redirect; }
/* harmony export */ });
/* unused harmony export isTradlyIntegrationHaveValidateSignature */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46316);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42474);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12918);




// validateSignature
var isTradlyIntegrationHaveValidateSignature = function(payload, providedSig, secret) {
    try {
        var calculatedSig = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", secret).update(payload).digest("hex");
        return calculatedSig === providedSig;
    } catch (error) {
        console.error("Error validating signature:", error);
        return false;
    }
};
var check_tradly_auth_integration_payload = function(param) {
    var component = param.component, sso = param.sso, sig = param.sig;
    var decodedPayload = decodeBase64(sso);
    var ref = decodedPayload ? JSON.parse(decodedPayload) : {}, nonce = ref.nonce, return_url = ref.return_url;
    var TradlyIntegrationConnectSecret = "419ADD89629DGYA2E647527E6E7EF8344";
    var isValidSignature = isTradlyIntegrationHaveValidateSignature(decodedPayload, sig, TradlyIntegrationConnectSecret);
    if (isValidSignature) {
        return component;
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
};
var decodeBase64 = function(encodedString) {
    try {
        var decodedString = atob(encodedString);
        return decodedString;
    } catch (error) {
        console.error("Error decoding Base64:", error);
        return null;
    }
};
var tradly_integration_redirect = function(param) {
    var sso = param.sso, sig = param.sig, router = param.router, user = param.user;
    var decodedPayload = decodeBase64(sso);
    var ref = JSON.parse(decodedPayload), nonce = ref.nonce, return_url = ref.return_url;
    var payloadObj = {
        nonce: nonce,
        external_id: user.id,
        email: user.email,
        username: user.email,
        first_name: user.name,
        last_name: "",
        email_verified: user.email_verified
    };
    var encodedPayload = btoa(JSON.stringify(payloadObj));
    var discourseConnectSecret = "419ADD89629DGYA2E647527E6E7EF8344";
    var hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", discourseConnectSecret);
    hmac.update(JSON.stringify(payloadObj));
    var signature = hmac.digest("hex");
    var queryParams = new URLSearchParams({
        payload: encodedPayload,
        sig: signature
    });
    window.location.href = "".concat(decodeURIComponent(return_url), "?").concat(queryParams.toString());
};


/***/ })

}]);